import { renderToString } from 'react-dom/server';
import { Direction } from '@material-ui/core';
import { LanguageCode } from '__generated__/globalTypes';
import { STRINGS } from 'constants/strings';
import constant from 'utils/constant';

export const STRING_CONST = {
    STYLE_DETAILS: 'STYLE_DETAILS',
    SHOP_ITEM: 'SHOP_ITEM',
    SHOP_NOW: 'SHOP_NOW',
    READ_MORE: 'READ_MORE',
    VIEW_STYLE: 'VIEW_STYLE',
    VIEW_ITEM: 'VIEW_ITEM',
    // SUGGEST_SPECIAL_OCCASION_STYLE: 'SUGGEST_SPECIAL_OCCASION_STYLE',
    // SUGGEST_WINTER_STYLE: 'SUGGEST_WINTER_STYLE',
    SUGGEST_STYLE_TIPS: 'SUGGEST_STYLE_TIPS',
    LETS_GET_STARTED: 'LETS_GET_STARTED',
    TRENDING_QUESTION_MESSAGE_OPENING_CONVERSATION: 'TRENDING_QUESTION_MESSAGE_OPENING_CONVERSATION',
    TRENDING_QUESTION_MESSAGE: 'TRENDING_QUESTION_MESSAGE',
    WELCOME_BACK_MESSAGE: 'WELCOME_BACK_MESSAGE',
    STRINGS: 'STRINGS',
    SETTINGS: 'SETTINGS',
    DIRECTION: 'DIRECTION',
    TEXT_ALIGN: 'TEXT_ALIGN',
    TYPE_WRITING_METHOD: 'TYPE_WRITING_METHOD',
    START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
    FAQ_CUSTOM_QUESTION: 'FAQ_CUSTOM_QUESTION',
    ASK_ANOTHER_QUESTION: 'ASK_ANOTHER_QUESTION',
};

export const DEFAULT_SUPPORTING_LANGUAGES = [LanguageCode.arabic, LanguageCode.english];

export enum TYPE_WRITING_METHODS {
    CHAR = 'CHAR',
    WORD = 'WORD',
}
const LANGUAGE_CONST = {
    [LanguageCode.arabic]: {
        [STRING_CONST.STRINGS]: {
            [STRING_CONST.STYLE_DETAILS]: 'تفاصيل الستايل',
            [STRING_CONST.SHOP_ITEM]: 'تسوق القطعة',
            [STRING_CONST.SHOP_NOW]: 'تسوق الآن',
            [STRING_CONST.READ_MORE]: 'اقرأ المزيد',
            [STRING_CONST.VIEW_STYLE]: 'عرض الستايل',
            [STRING_CONST.VIEW_ITEM]: 'عرض القطعة',
            // [STRING_CONST.SUGGEST_SPECIAL_OCCASION_STYLE]: 'اقترحي ستايلات لمناسبة مميزة',
            // [STRING_CONST.SUGGEST_WINTER_STYLE]: 'اقترحي ستايلات للخريف او الشتاء',
            // [STRING_CONST.SUGGEST_STYLE_TIPS]: 'أحتاج استشارة نصائح وطرق تنسيق الستايل',
            [STRING_CONST.LETS_GET_STARTED]: 'لنبدأ',
            [STRING_CONST.TRENDING_QUESTION_MESSAGE_OPENING_CONVERSATION]:
                'يمكنك تجربة طرح الأسئلة المقترحة التالية علي.',
            [STRING_CONST.TRENDING_QUESTION_MESSAGE]: 'لست متأكداً مما تسأل؟ جرّب أحد أسئلة التنسيق المقترحة التالية.',
            [STRING_CONST.WELCOME_BACK_MESSAGE]: 'مرحباً بعودتك! كيف يمكنني مساعدتك في تنسيق إطلالتك اليوم؟ 👗🕴️',
            [STRING_CONST.START_NEW_CONVERSATION]: 'ابدأ محادثة جديدة',
            [STRING_CONST.FAQ_CUSTOM_QUESTION]: 'شيء آخر؟ اسأل أميرة',
            [STRING_CONST.ASK_ANOTHER_QUESTION]: 'اطرح سؤالاً آخر',
        },
        [STRING_CONST.SETTINGS]: {
            [STRING_CONST.DIRECTION]: constant.DIRECTIONS.RTL,
            [STRING_CONST.TEXT_ALIGN]: constant.TEXT_ALIGN.RIGHT,
            [STRING_CONST.TYPE_WRITING_METHOD]: TYPE_WRITING_METHODS.WORD,
        },
    },
    [LanguageCode.english]: {
        [STRING_CONST.STRINGS]: {
            [STRING_CONST.STYLE_DETAILS]: 'Style Details',
            [STRING_CONST.SHOP_ITEM]: 'SHOP THE ITEM',
            [STRING_CONST.SHOP_NOW]: 'SHOP NOW',
            [STRING_CONST.READ_MORE]: 'Read More',
            [STRING_CONST.VIEW_STYLE]: 'View Style',
            [STRING_CONST.VIEW_ITEM]: 'View Item',
            // [STRING_CONST.SUGGEST_SPECIAL_OCCASION_STYLE]: 'Suggest looks for a special occasion.',
            // [STRING_CONST.SUGGEST_WINTER_STYLE]: 'Suggest winter/fall styles.',
            // [STRING_CONST.SUGGEST_STYLE_TIPS]: 'I need style tips and advice.',
            [STRING_CONST.LETS_GET_STARTED]: 'Let us get started.',
            [STRING_CONST.TRENDING_QUESTION_MESSAGE_OPENING_CONVERSATION]:
                'You can try asking me the following suggested questions.',
            [STRING_CONST.TRENDING_QUESTION_MESSAGE]:
                'Not sure what to ask? Try one of these suggested style questions.',
            [STRING_CONST.WELCOME_BACK_MESSAGE]: 'Welcome back. How can I style you today? 👗🕴️',
            [STRING_CONST.START_NEW_CONVERSATION]: 'START NEW CONVERSATION',
            [STRING_CONST.FAQ_CUSTOM_QUESTION]: 'Something else ? Ask Amira',
            [STRING_CONST.ASK_ANOTHER_QUESTION]: 'Ask another question',
        },
        [STRING_CONST.SETTINGS]: {
            [STRING_CONST.DIRECTION]: constant.DIRECTIONS.LTR,
            [STRING_CONST.TEXT_ALIGN]: constant.TEXT_ALIGN.LEFT,
            [STRING_CONST.TYPE_WRITING_METHOD]: TYPE_WRITING_METHODS.CHAR,
        },
    },
};

const getLanguageStr = (str, lang) => {
    if (lang in LANGUAGE_CONST) {
        return LANGUAGE_CONST[lang][STRING_CONST.STRINGS][str];
    }
    return STRINGS[str];
};

const getLanguageElement = (str, lang) => {
    return renderToString(<div style={{ ...getLanguageStyle(lang) }}>{str}</div>);
};

const getLanguageStyle = (lang) => {
    if (lang in LANGUAGE_CONST) {
        return { direction: LANGUAGE_CONST[lang][STRING_CONST.SETTINGS][STRING_CONST.DIRECTION] as Direction };
    }
    return { direction: constant.DIRECTIONS.LTR as Direction };
};
const getLanguageStyles = (lang) => {
    if (lang in LANGUAGE_CONST) {
        return { textAlign: LANGUAGE_CONST[lang][STRING_CONST.SETTINGS][STRING_CONST.TEXT_ALIGN] as CanvasTextAlign };
    }
    return { textAlign: 'left' as CanvasTextAlign };
};

const getMarginForDir = (lang, value) => {
    if (getLanguageStyle(lang)?.direction === constant.DIRECTIONS.RTL) {
        return `0px ${value} 0px 0px`;
    }
    return `0px 0px 0px ${value}`;
};

const getTypeWritingMethod = (lang) => {
    if (lang in LANGUAGE_CONST) {
        return LANGUAGE_CONST[lang][STRING_CONST.SETTINGS][STRING_CONST.TYPE_WRITING_METHOD];
    }
    return TYPE_WRITING_METHODS.WORD;
};

const langUtils = {
    getLanguageStr,
    getLanguageElement,
    getLanguageStyle,
    getMarginForDir,
    getTypeWritingMethod,
    getLanguageStyles,
};

export default langUtils;
